function _isCharAllowed(e, pressedChar) {
    var targetValue = e.target.value;

    if ($.isNumeric(pressedChar)) {
        return true;
    }

    if (pressedChar === '-'
        && targetValue.indexOf('-') < 0
        && e.target.selectionStart == 0) {
        return true;
    }

    if (/[,.]/i.test(pressedChar) && !/[,.]/i.test(targetValue)) {
        return true;
    }

    return false;
}

//TODO: limit amount of characters after decimal separator
// function _getNextTargetValue(e, pressedChar) {
//     var selectionStart = e.target.selectionStart;
//     var selectionEnd = e.target.selectionEnd;
//     var firstPart = e.target.value.slice(0, selectionStart);
//     var secondPart = e.target.value.slice(selectionEnd);
//     return firstPart + pressedChar + secondPart;
// }

/*@ngInject*/
module.exports = function ($filter) {
    return {
        require: 'ngModel',
        scope: {
            step: '='
        },
        link: function (scope, elm, attrs, ctrl) {
            var fraction = attrs.fraction || 2;

            elm.on('keypress', function (e) {
                var pressedChar = String.fromCharCode(e.keyCode || e.which);
                if (!_isCharAllowed(e, pressedChar)) {
                    e.stopImmediatePropagation();
                    return false;
                }
            });

            ctrl.$parsers.unshift(function (viewValue) {
                if (!viewValue) {
                    ['float', 'min', 'max'].forEach(function (x) {
                        ctrl.$setValidity(x, true);
                    });
                    return undefined;
                }

                var number = validateAndGetNumber(viewValue, ctrl, attrs);

                if (!number && number !== 0) {
                    ctrl.$setValidity('float', false);
                    return undefined;
                }

                if (!validateMinMax(viewValue, ctrl, attrs)) {
                    return undefined;
                }

                if (fraction) {
                    var roundedNumber = $filter('estNumber')(number, fraction, '');
                    return parseFloat(roundedNumber.replace(',', '.'));
                }

                return number;
            });

            ctrl.$formatters.unshift(
                function (modelValue) {
                    return $filter('estNumber')(modelValue, fraction, '');
                }
            );
        }
    };
};

function validateAndGetNumber(viewValue, ctrl, attrs) {
    var FLOAT_REGEXP = /^[-+]?\$?\d+([.,]\d*)?$/;

    if (FLOAT_REGEXP.test(viewValue)) {
        ctrl.$setValidity('float', true);
        return parseFloat(viewValue.replace(',', '.'));
    }
}

function validateMinMax(viewValue, ctrl, attrs) {
    if (attrs.min && viewValue < parseFloat(attrs.min)) {
        ctrl.$setValidity('min', false);
        return false;
    } else {
        ctrl.$setValidity('min', true);
    }

    if (attrs.max && viewValue > parseFloat(attrs.max)) {
        ctrl.$setValidity('max', false);
        return false;
    } else {
        ctrl.$setValidity('max', true);
    }

    return true;
}



/** WEBPACK FOOTER **
 ** ./app/shared/directives/smartfloat.directive.js
 **/